import React from 'react';

import { Spinner } from 'modules/ui/components';

import { useLatestModelTimes } from '../../hooks';
import { formatLatestModelRun } from '../../utils/time';

const MeteoSourcesInfo: React.FC = () => {
  const { latestTimes, isLoading } = useLatestModelTimes();

  return (
    <span>
      {isLoading && <Spinner />}
      {latestTimes && (
        <>
          <br />
          <b>Latest model runs:</b>
          <br />
          {` ECMWF — Wind ${formatLatestModelRun(
            latestTimes.ecmwf.wind,
          )}, Weather ${formatLatestModelRun(
            latestTimes.ecmwf.meteo,
          )}, Waves ${formatLatestModelRun(latestTimes.ecmwf.wave)}.`}
          <br />

          {` GFS — Wind ${formatLatestModelRun(
            latestTimes.ncep.wind,
          )}, Weather ${formatLatestModelRun(
            latestTimes.ncep.meteo,
          )}, Waves ${formatLatestModelRun(latestTimes.ncep.wave)}.`}
          <br />

          {` Mercator NEMO — Ocean ${formatLatestModelRun(
            latestTimes.mercator.ocean,
          )}.`}
        </>
      )}
    </span>
  );
};

export default React.memo(MeteoSourcesInfo);
